export enum PayOtherAmountV1Error {
  DocumentNotFoundForAccounts = 'documents.not.found.for.accounts',
}
